import { authHeader } from '../../_helpers';
import axios from 'axios';

export const role_fitmentSevice = {
    getRoleFitments,
    getRoleHolders,
    getRoleFitmentData
}

axios.defaults.headers.common = authHeader();


function getRoleFitments() {
    let token = localStorage.getItem('access_token')
    return axios.get(`/users/fitment/list/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function getRoleHolders() {
    let token = localStorage.getItem('access_token')
    return axios.get(`/users/holder/list/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function getRoleFitmentData(data) {
    let token = localStorage.getItem('access_token')
    return axios.post(`/analytics/analytics_organisation/team/analyse/role_fitment/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/role_fitment.service.js